export class RejectReasonsDto {

    private reasons: any[];
    private comment: String;
    private status: String;

    constructor(RejectReasonsDto: any) {

        this.reasons = [];
        if (RejectReasonsDto.reasons) {
            this.reasons = [];
            for (const document of RejectReasonsDto.reasons) {
                this.reasons.push(document);
            }
        }
        this.comment = RejectReasonsDto.comment;
        this.status = RejectReasonsDto.status;
    }


    /**
     * Getter $queryResponseTimestamp
     * @return {reasons}
     */
     public get $reasons(): any[] {
        return this.reasons;
    }

    /**
     * Setter $queryResponseTimestamp
     * @param {reasons} value
     */
     public set $reasons(value: any[]) {
        this.reasons = value;
    }

     /**
     * Getter $comment
     * @return {comment}
     */
      public get $comment(): String {
        return this.comment;
    }

    /**
     * Setter $comment
     * @param {comment} value
     */
     public set $comment(value: String) {
        this.comment = value;
    }

     /**
     * Getter $status
     * @return {status}
     */
      public get $status(): String {
        return this.status;
    }

    /**
     * Setter $status
     * @param {status} value
     */
     public set $status(value: String) {
        this.status = value;
    }

}
